import axios, { AxiosResponse } from "axios";
import { AdminJobApi } from "go-component/services/types";
import { parseApiData } from "go-core/api/parseApiData";
import { getSearchSelectPage, mapToBase } from "go-core/api/searchSelectService";
import { ItemResponse } from "go-core/api/types";
import { restSecurityApi } from "go-security/services/Api/api";
import OrganizationIdService from "go-security/services/organizationIdService";
import { getApiURL } from "../../utils/envutil";
import { ConfigApi } from "../Config/types";
import { apiOrganization } from "./Organization/apiOrganization";
import { SearchSelectApi } from "./types";

class api {
	static getOrganizationId = () => {
		return OrganizationIdService.getWithCheck();
	};

	static async getConfig(): Promise<AxiosResponse<ItemResponse<ConfigApi>>> {
		return axios.get("/ajax/config", {
			baseURL: getApiURL(),
			withCredentials: true,
		});
	}

	static organization() {
		return apiOrganization;
	}

	static async test() {
		// return restSecurityApi.get(`/security/${id}/me`)
		return restSecurityApi.get(`/test`);
	}

	// GROUP REPORTS

	static async getGroupStateReports(
		params: Record<string, any>,
		options?: Record<string, any>
	): Promise<AxiosResponse> {
		return restSecurityApi.get("/reports/states", {
			params,
			cancelToken: options?.cancelToken,
		});
	}

	static async getGroupProductReports(
		params: Record<string, any>,
		options?: Record<string, any>
	): Promise<AxiosResponse> {
		return restSecurityApi.get("/reports/products/fifo", {
			params,
			cancelToken: options?.cancelToken,
		});
	}

	static async getGroupProductSalesReports(
		params: Record<string, any>,
		options?: Record<string, any>
	): Promise<AxiosResponse> {
		return restSecurityApi.get("/reports/sales_orders_products", {
			params,
			cancelToken: options?.cancelToken,
		});
	}

	static async getGroupPurchaseReports(
		params: Record<string, any>,
		options?: Record<string, any>
	): Promise<AxiosResponse> {
		return restSecurityApi.get("/reports/purchase_orders", {
			params,
			cancelToken: options?.cancelToken,
		});
	}

	static async getGroupSaleReports(
		params: Record<string, any>,
		options?: Record<string, any>
	): Promise<AxiosResponse> {
		return restSecurityApi.get("/reports/sales_orders", {
			params,
			cancelToken: options?.cancelToken,
		});
	}

	static async getGroupTransferReports(
		params: Record<string, any>,
		options?: Record<string, any>
	): Promise<AxiosResponse> {
		return restSecurityApi.get("/reports/transfer_orders", {
			params,
			cancelToken: options?.cancelToken,
		});
	}

	static async getGroupCorrectionReports(
		params: Record<string, any>,
		options?: Record<string, any>
	): Promise<AxiosResponse> {
		return restSecurityApi.get("/reports/corrections", {
			params,
			cancelToken: options?.cancelToken,
		});
	}

	static async getGroupFIFOReports(
		params: Record<string, any>,
		options?: Record<string, any>
	): Promise<AxiosResponse> {
		return restSecurityApi.get("/reports/fifo", {
			params,
			cancelToken: options?.cancelToken,
		});
	}

	static async getGroupStocktakingReports(
		params: Record<string, any>,
		options?: Record<string, any>
	): Promise<AxiosResponse> {
		return restSecurityApi.get("/reports/stocktakings/fifo", {
			params,
			cancelToken: options?.cancelToken,
		});
	}

	static async getGroupAdjustmentReports(
		params: Record<string, any>,
		options?: Record<string, any>
	): Promise<AxiosResponse> {
		return restSecurityApi.get("/reports/stock_adjustments", {
			params,
			cancelToken: options?.cancelToken,
		});
	}

	static getJobs(params?: Record<string, any>, options?: Record<string, any>): Promise<AdminJobApi[]> {
		return parseApiData(
			restSecurityApi.get("jobs/in_memory", {
				params,
				cancelToken: options?.cancelToken,
			})
		);
	}

	static async getGroupPriceReports(
		params: Record<string, any>,
		options?: Record<string, any>
	): Promise<AxiosResponse> {
		return restSecurityApi.get("/reports/prices", {
			params,
			cancelToken: options?.cancelToken,
		});
	}

	static async getStockSearchSelect(
		t: string,
		obj: Record<string, any>,
		options?: Record<string, any>
	): Promise<SearchSelectApi[]> {
		const newObj = JSON.parse(JSON.stringify(obj));
		delete newObj.ids;

		const f = mapToBase(t, newObj);
		const page = getSearchSelectPage(newObj);
		return parseApiData(
			restSecurityApi.get(`stocks/search_select?f=${f}&page=${page}`, {
				cancelToken: options?.cancelToken,
			})
		);
	}
}

export { api };
